module.exports = __webpack_public_path__ + "img/filter-form-v2.1363386f.svg";